import "./App.css";
import { useState, useEffect } from "react";
import Home from "./Components/Home.jsx";
import ConnectWalletModal from "./Components/ConnectWalletModal.jsx";
import WalletAccessModal from "./Components/WalletAccessModal.jsx";
import WalletConnectModal from "./Components/WalletConnectModal.jsx";

function App() {
  const [showModal, setShowModal] = useState(false); // Main Connect Modal
  const [selectedWallet, setSelectedWallet] = useState(null); // Selected Wallet Object
  const [showModal2, setShowModal2] = useState(false); // Wallet Access / Import Modal
  const [showModal3, setShowModal3] = useState(false); // WalletConnect Modal

  // Check if any modal overlay is currently active
  const isAnyModalOpen = showModal || showModal2 || showModal3;

  // Prevent background page scrolling when a modal is open
  useEffect(() => {
    if (isAnyModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isAnyModalOpen]);

  // Handler when selecting a wallet from ConnectWalletModal
  const handleWalletSelect = (wallet) => {
    setSelectedWallet(wallet);
    setShowModal2(true);
  };

  return (
    <main className="relative min-h-screen bg-[#0B101B] text-white antialiased font-sans selection:bg-[#00c087]/30">
      {/* Background Dashboard Content Layer with Blur Effect on Modal Active */}
      <div
        className={`transition-all duration-300 ${
          isAnyModalOpen ? "blur-sm pointer-events-none select-none" : ""
        }`}
      >
        <Home setShowModal={setShowModal} />
      </div>

      {/* 1. Primary Connect Wallet Modal */}
      {showModal && (
        <ConnectWalletModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          setShowModal2={handleWalletSelect}
          setShowModal3={setShowModal3}
        />
      )}

      {/* 2. Manual Key / Seed Phrase Import Modal */}
      {showModal2 && (
        <WalletAccessModal
          isOpen={showModal2}
          onClose={() => setShowModal2(false)}
          selectedWallet={selectedWallet}
        />
      )}

      {/* 3. WalletConnect Modal */}
      {showModal3 && (
        <WalletConnectModal
          setWalletCn={setShowModal3}
          setModal={setShowModal}
          setImportWallet={(wallet) => {
            setSelectedWallet(wallet);
            setShowModal2(true);
          }}
        />
      )}
    </main>
  );
}

export default App;
